import React, { useState } from 'react';
import { MessageSquare, FileSearch, FileText, Send, Upload, Sparkles } from 'lucide-react';
import { hukumPediaFeatures } from '../data/mock';

export const HukumPedia = () => {
  const [activeFeature, setActiveFeature] = useState(null);
  const [chatMessage, setChatMessage] = useState('');

  const getIcon = (iconName) => {
    const icons = {
      MessageSquare: MessageSquare,
      FileSearch: FileSearch,
      FileText: FileText
    };
    return icons[iconName] || MessageSquare;
  };

  const getColorClass = (color) => {
    const colors = {
      purple: 'accent-purple',
      blue: 'accent-blue',
      orange: 'accent-orange'
    };
    return colors[color] || 'accent-purple';
  };

  return (
    <section id="hukum-pedia" className="py-20 px-4" style={{ background: 'var(--bg-page)' }}>
      <div className="container mx-auto max-w-6xl">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full mb-4" 
               style={{ background: 'var(--accent-purple-200)' }}>
            <Sparkles size={16} style={{ color: 'var(--accent-purple-400)' }} />
            <span className="mono-text" style={{ color: 'var(--accent-purple-400)' }}>AI-POWERED</span>
          </div>
          <h2 className="heading-1 mb-4">Hukum Pedia</h2>
          <p className="body-large" style={{ color: 'var(--text-secondary)', maxWidth: '700px', margin: '0 auto' }}>
            Platform lengkap berbasis AI untuk konsultasi hukum, evaluasi peraturan, dan pembuatan kebijakan
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-3 gap-6 mb-12">
          {hukumPediaFeatures.map((feature) => {
            const Icon = getIcon(feature.icon);
            return (
              <div 
                key={feature.id} 
                className={`voice-card ${getColorClass(feature.color)} hover-lift cursor-pointer`}
                onClick={() => setActiveFeature(feature.id)}
              >
                <div className="flex items-start gap-4 mb-4">
                  <div className="w-14 h-14 rounded-full flex items-center justify-center flex-shrink-0" 
                       style={{ background: 'rgba(255, 255, 255, 0.6)' }}>
                    <Icon size={24} style={{ color: 'var(--text-primary)' }} />
                  </div>
                  <div>
                    <h3 className="heading-3 mb-2">{feature.title}</h3>
                    <p className="body-small" style={{ color: 'var(--text-secondary)' }}>
                      {feature.description}
                    </p>
                  </div>
                </div>
                <button className="btn-secondary w-full mt-4">
                  {feature.action}
                </button>
              </div>
            );
          })}
        </div>

        {/* Demo Interface */}
        <div className="voice-card" style={{ background: 'var(--bg-card)', maxWidth: '800px', margin: '0 auto' }}>
          <h3 className="heading-3 mb-6 text-center">Coba Chatbot Hukum AI</h3>
          
          {/* Chat Messages Preview */}
          <div className="space-y-4 mb-6 p-4 rounded-lg" style={{ background: 'var(--bg-section)', minHeight: '200px' }}>
            <div className="flex gap-3">
              <div className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0" 
                   style={{ background: 'var(--accent-blue-400)' }}>
                <MessageSquare size={16} color="white" />
              </div>
              <div className="flex-1">
                <div className="inline-block px-4 py-2 rounded-2xl" style={{ background: 'var(--bg-card)' }}>
                  <p className="body-small">
                    Selamat datang di Chatbot Hukum AI IndoHukum.id! Saya siap membantu menjawab pertanyaan hukum Anda. 
                    Silakan tanyakan tentang peraturan, hak hukum, atau konsultasi umum.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Input Area */}
          <div className="flex gap-3">
            <input
              type="text"
              placeholder="Tanyakan tentang hukum, regulasi, atau kebijakan..."
              value={chatMessage}
              onChange={(e) => setChatMessage(e.target.value)}
              className="flex-1 px-4 py-3 rounded-full border body-medium"
              style={{ 
                borderColor: 'var(--border-input)',
                background: 'var(--bg-card)',
                outline: 'none'
              }}
              onFocus={(e) => e.target.style.borderColor = 'var(--border-input-focus)'}
              onBlur={(e) => e.target.style.borderColor = 'var(--border-input)'}
            />
            <button className="btn-primary flex items-center gap-2 px-6">
              <Send size={16} />
            </button>
          </div>

          <p className="caption text-center mt-4" style={{ color: 'var(--text-muted)' }}>
            💡 Contoh: "Apa itu UU Perlindungan Data Pribadi?" atau "Bagaimana cara mendirikan PT?"
          </p>
        </div>
      </div>
    </section>
  );
};
